// extracted by mini-css-extract-plugin
export default {"main":"CreateClient_main__aQvyq"};